import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import SectionHeader from '../../../../Components/GeneralComponents/SectionHeader';
import { useNavigate, useParams } from 'react-router-dom';
import { getProject } from '../../../../Requests/ProjectRequests';
import CreateEditProjectSlideover from '../../../../Components/Projects/CreateEditProjectSlideover';
import { Card } from '@tremor/react';
import NewAudioFileUploadModal from '../../../../Components/Files/NewAudioFileUploadModal';
import AnalisysCard from '../../../../Components/Files/AnalisysCard';
import ProjectGpt from '../../../../Components/ProjectGpt/ProjectGpt';
import UploadFileModal from '../../../../Components/Text/TextUploadModal';
import UploadFileWithTypes from '../../../../Components/NewAnalysisElements/UploadFileWithTypes';
import { CheckIcon, Cog6ToothIcon, DocumentArrowUpIcon, PencilIcon, TagIcon, TrashIcon, UserIcon, XMarkIcon } from '@heroicons/react/24/outline';
import empty_file_cabinet from '../../../../Assets/Project/empty_file_cabinet.png'
import text_coder from '../../../../Assets/TextCoder/text_coder.png'
import no_subjects from '../../../../Assets/Subjects/subject_image.png'
import TextCodeModal from '../../../../Components/TextCoder/TextCodeModal';
import { getTextCodes } from '../../../../Requests/TextCoderRequests';
import TextCodeExcerptsModal from '../../../../Components/TextCoder/TextCodeExcerptsModal';
import { getTeamUuid } from '../../../../utils/cookies';
import TextTranscriptionUploadModal from '../../../../Components/Text/TextTranscriptionModal';
import UpgradedLoader from '../../../../Components/UpgradedLoader';
import { getAiCodes } from '../../../../Requests/AICodeFinder';
import AICodeFinder from '../../../../Components/AICodeFinder/AICodeFinder';
import AICodeView from '../../../../Components/AICodeFinder/AICodeView';
import TranscriptionCodeView from '../../../../Components/TranscriptionCodeFinder.js/TranscriptionCodeView';
import { ShareIcon } from '@heroicons/react/20/solid';
import TextCodeCombinationModal from '../../../../Components/TextCoder/TextCodeCombinationModal';
import CodeCard from '../../../../Components/TextCoder/CodeCard';
import SubjectPropertiesModal from '../../../../Components/Subjects/SubjectPropertiesModal';
import SubjectCreationModal from '../../../../Components/Subjects/SubjectCreationModal';
import { deleteSubject } from '../../../../Requests/SubjectRequests';
import SubjectPublicFormModal from '../../../../Components/Subjects/SubjectPublicFormModal';
import HierarchicalTables from '../../../../Components/Results/HierarchicalTables';
import Codebook from '../../../../Components/Codebook/Codebook';
import CodeFilePresenceMatrix from '../../../../Components/Results/CodeFilePresenceMatrix';
import PolarAreaCenterLabelsChart from '../../../../Components/Results/PolarAreaCenterLabelsChart';
import PolarAreaChartsPerInterview from '../../../../Components/Results/PolarAreaChartsPerInterview';
import ErrorBoundary from '../../../../Components/ErrorBoundary/ErrorBoundary';
import ArticlesTab from '../../../../Components/Articles/ArticlesTab';
import BibliographyTab from '../../../../Components/Articles/BibliographyTab';
import ProjectDeletionDateSlideover from '../../../../Components/Projects/ProjectDeletionDateSlideover';
import { getProjectDeletionInfo } from '../../../../Requests/ProjectRequests';

function classNames(...classes) {
    return classes.filter(Boolean).join(' ');
}

function DetailProject() {
    const { project_uuid } = useParams();
    const { t } = useTranslation();
    const [project, setProject] = useState(null);
    const [projectSlideover, setProjectSlideOver] = useState(null);
    const [uploadAudioModal, setUploadAudioModal] = useState(null);
    const [textCodes, setTextCodes] = useState(null)
    const [currentTab, setCurrentTab] = useState(0);
    const [deletionInfo, setDeletionInfo] = useState(null);
    const [deletionSlideover, setDeletionSlideover] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        if (!project_uuid) {
            //navigate("/projects")
        } else {
            getProject(project_uuid).then((res) => {
                setProject(res.data);
            }).catch((error) => {

            });
            
            // Fetch deletion info
            getProjectDeletionInfo(project_uuid).then((res) => {
                setDeletionInfo(res.data);
            }).catch((error) => {
                // Silently handle error - deletion info is optional
            });
        }
    }, [project_uuid]);

    let tabs = [
        { name: t("DetailProjects.AnalysisTab"), href: '#', current: currentTab === 0, id: 0, visible: true },
        { name: t("DetailProjects.Subjects"), href: '#', current: currentTab === 6, id: 6, visible: true },
        { name: t("DetailProjects.ProjectGPT"), href: '#', current: currentTab === 1, id: 1, visible: true },
        { name: t("DetailProjects.Project codes"), href: '#', current: currentTab === 2, id: 2, visible: true },
        { name: t("DetailProjects.Coder"), href: '#', current: currentTab === 3, id: 3, visible: true },
        //{ name: t("AiCodeDiscovery.Title"), href: '#', current: currentTab === 4, id: 4, visible: (process.env.REACT_APP_BETA_USERS.split(",")).includes(getTeamUuid()) },
        //{ name: t("AiCodeFinder.Title"), href: '#', current: currentTab === 5, id: 5, visible: (process.env.REACT_APP_BETA_USERS.split(",")).includes(getTeamUuid()) },
        { name: t("AiCodeDiscovery.Title"), href: '#', current: currentTab === 4, id: 4, visible: true },
        { name: t("AiCodeFinder.Title"), href: '#', current: currentTab === 5, id: 5, visible: true },
        { name: t("CategoryResults.Title"), href: '#', current: currentTab === 7, id: 7, visible: true },
        { name: t("DetailProjects.Bibliography"), href: '#', current: currentTab === 9, id: 9, visible: true },
        { name: t("DetailProjects.Articles"), href: '#', current: currentTab === 8, id: 8, visible: true },
    ]



    const handleNewFileUpload = (type) => {
        if (type === "Audio") {
            setUploadAudioModal(<NewAudioFileUploadModal handleClose={() => { setUploadAudioModal(null); }} project={project} />);
        } else if (type === "Pdf") {
            setUploadAudioModal(<UploadFileModal handleClose={() => { setUploadAudioModal(null); }} />);
        } else if (type == "Transcription") {
            setUploadAudioModal(<TextTranscriptionUploadModal handleClose={() => { setUploadAudioModal(null); }} />);
        }
    };

    const handleChangeTab = (e) => {
        let tab_index = e;
        if (tab_index == 3) {
            navigate("/text_coder/" + project_uuid)
        } else {
            setCurrentTab(e)
        }
    }

    useEffect(() => {
        if (!textCodes) {
            getTextCodes(project_uuid).then((res) => {
                setTextCodes(res.data)
            }).catch((error) => {

            });
        }
    }, [])



    function handleUpdateCode(updatedCode) {
        setTextCodes(prevCodes => prevCodes.map(code => code.uuid === updatedCode.uuid ? updatedCode : code));
    }
    function handleAddNewCode(newCode) {
        setTextCodes(prevCodes => [...prevCodes, newCode]);
    }
    function handleCombineCodes(codesToDelete, newCode) {
        setTextCodes(prevCodes => {
            // Filter out the codes to be deleted
            const updatedCodes = prevCodes.filter(code => !codesToDelete.includes(code.uuid));

            // Add the new combined code
            return [...updatedCodes, newCode];
        });
    }

    const formatPropertyValue = (prop) => {
        if (prop.property_definition?.type === 'boolean') {
            return prop.value ? t('Common.Yes') : t('Common.No');
        }
        return prop.value;
    };

    const shouldShowDeletionInfo = () => {
        if (!deletionInfo) return false;
        const isScheduled = deletionInfo.is_deletion_scheduled;
        return isScheduled && deletionInfo.scheduled_deletion_at;
    };

    const isUrgentDeletion = () => {
        if (!deletionInfo) return false;
        
        const isDue = deletionInfo.is_deletion_due;
        const needsWarning = deletionInfo.needs_warning;
        
        // Check if deletion is within 48 hours
        const hoursUntilDeletion = getHoursUntilDeletion();
        const isWithin48Hours = hoursUntilDeletion !== null && hoursUntilDeletion <= 48 && hoursUntilDeletion > 0;
        
        // Check if deletion is within 7 days (but more than 48 hours)
        const daysUntilDeletion = getDaysUntilDeletion();
        const isWithinWeek = daysUntilDeletion !== null && daysUntilDeletion <= 7 && daysUntilDeletion > 2;
        
        return isDue || needsWarning || isWithin48Hours || isWithinWeek;
    };
    
    const getDaysUntilDeletion = () => {
        if (!deletionInfo?.scheduled_deletion_at) return null;
        const deletionDate = new Date(deletionInfo.scheduled_deletion_at);
        const now = new Date();
        const diffTime = deletionDate - now;
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        return diffDays;
    };

    const getHoursUntilDeletion = () => {
        if (!deletionInfo?.scheduled_deletion_at) return null;
        const deletionDate = new Date(deletionInfo.scheduled_deletion_at);
        const now = new Date();
        const diffTime = deletionDate - now;
        const diffHours = Math.ceil(diffTime / (1000 * 60 * 60));
        return diffHours;
    };

    const getDeletionDisplayMessage = () => {
        if (!deletionInfo) return '';
        
        if (deletionInfo.is_deletion_due) {
            return t('ProjectDeletion.WarningDue');
        }
        
        const hoursUntilDeletion = getHoursUntilDeletion();
        const daysUntilDeletion = getDaysUntilDeletion();
        
        // Show hours if less than 48 hours
        if (hoursUntilDeletion !== null && hoursUntilDeletion <= 48 && hoursUntilDeletion > 0) {
            return t('ProjectDeletion.WarningHours', { hours: hoursUntilDeletion });
        }
        
        // Show days for all other cases
        if (daysUntilDeletion !== null && daysUntilDeletion > 0) {
            return t('ProjectDeletion.WarningDays', { days: daysUntilDeletion });
        }
        
        return '';
    };





    return (
        <div data-testid="detail-project-container" className='md:pl-64 pt-4 md:pt-12 w-full flex justify-center'>
            <div data-testid="detail-project-content-wrapper" className='flex flex-col w-full justify-center items-center px-4'>
                {project && <div data-testid="detail-project-header-card" className='bg-white max-w-7xl rounded-2xl w-full h-full shadow-xl mx-8'>
                    <SectionHeader
                        data-testid="detail-project-section-header"
                        title={project.name}
                        subtitle={project.description}
                        actionTitle={t('Projects.Edit')}
                        actionFunction={() => { setProjectSlideOver(<CreateEditProjectSlideover handleClose={() => { setProjectSlideOver(null); }} project={project} />); }}
                        breadcrubs={[{ name: t('Projects.Title'), href: "/projects" }]}
                    />
                    {shouldShowDeletionInfo() && (
                        <div className="px-6 pb-4 flex justify-center">
                            <button
                                onClick={() => setDeletionSlideover(true)}
                                className={`text-sm underline cursor-pointer ${
                                    isUrgentDeletion() 
                                        ? 'text-red-600 hover:text-red-800' 
                                        : 'text-gray-500 hover:text-gray-700'
                                }`}
                            >
                                {isUrgentDeletion() && '⚠️ '}{getDeletionDisplayMessage()}
                            </button>
                        </div>
                    )}
                </div>}

                <div data-testid="detail-project-main-card" className='bg-white max-w-7xl rounded-2xl w-full h-full shadow-xl mx-8 my-8'>
                    <Card data-testid="detail-project-tabs-card">
                        <div data-testid="detail-project-tabs-container" className='flex flex-col lg:flex-row justify-between gap-2 whitespace-nowrap'>
                            <div data-testid="detail-project-mobile-tabs" className="sm:hidden">
                                <select
                                    data-testid="detail-project-tabs-select"
                                    id="tabs"
                                    name="tabs"
                                    className="block w-full rounded-md border-gray-300 focus:border-black focus:ring-black"
                                    onChange={(e) => handleChangeTab(Number(e.target.value))}
                                    value={currentTab}
                                >
                                    {tabs.map((tab) => (
                                        <option key={tab.id} data-testid={`detail-project-tab-option-${tab.id}`} value={tab.id}>{tab.name}</option>
                                    ))}

                                </select>
                            </div>
                            <div data-testid="detail-project-desktop-tabs" className="hidden sm:block">
                                <nav data-testid="detail-project-tabs-nav" className="flex gap-2 flex-wrap" aria-label="Tabs">
                                    {tabs.map((tab) => (
                                        tab.visible && <button
                                            key={tab.id}
                                            data-testid={`detail-project-tab-${tab.id}`}
                                            href={tab.href}
                                            className={classNames(
                                                tab.current ? 'bg-black text-white  ' : 'text-gray-500 hover:text-gray-700 border border-black ',
                                                'rounded-md px-3 py-2 text-xs font-medium whitespace-nowrap'
                                            )}
                                            aria-current={tab.current ? 'page' : undefined}
                                            onClick={() => handleChangeTab(tab.id)}
                                        >
                                            {tab.name}
                                        </button>
                                    ))}
                                </nav>
                            </div>

                            <div data-testid="detail-project-actions-section" className='flex justify-between'>

                                <button data-testid="detail-project-upload-file-btn" className='border border-black bg-white h-fit text-black rounded-md px-3 py-2 font-bold text-xs w-full lg:w-fit'
                                    type='button'
                                    onClick={() => {
                                        /*setUploadAudioModal(<NewAudioFileUploadModal handleClose={() => { setUploadAudioModal(null) }} project={project} */
                                        setUploadAudioModal(<UploadFileWithTypes handleClose={() => { setUploadAudioModal(null) }} handleNewFileUpload={handleNewFileUpload} />)
                                    }}
                                >
                                    <div className='w-full  flex justify-center items-center gap-2 whitespace-nowrap'>
                                        <DocumentArrowUpIcon className='w-4 h-4' />
                                        {t("DetailProjects.UploadFile")}
                                    </div>
                                </button>

                            </div>
                        </div>
                        {currentTab == 0 && <div data-testid="detail-project-analysis-tab">

                            {project?.analysis?.length > 0 ? <div data-testid="detail-project-analysis-grid" className='grid grid-cols-1 lg:grid-cols-2 py-4 justify-evenly gap-12 items-center'>

                                {project?.analysis?.map((current_analysis) => {
                                    return (<AnalisysCard data-testid={`analysis-card-${current_analysis.uuid}`} meeting={current_analysis} key={current_analysis.uuid} />)
                                })}

                            </div> :

                                (project == null ? <UpgradedLoader className="animate-pulse" w={8} h={8} bg="bg-black"></UpgradedLoader> :
                                    <div data-testid="detail-project-empty-analysis" className='w-full py-12 mt-4 mb-2 rounded-md bg-white p-4 flex flex-col items-center gap-8 flex-grow'>
                                        <div className='text-xl font-bold'>
                                            {t('DetailProjects.This project has no files yet')}
                                        </div>
                                        <div className='text-base text-gray-500 '>
                                            {t('DetailProjects.Add a file to start')}

                                        </div>
                                        <img src={empty_file_cabinet} className=' h-96 aspect-square mt-2'></img>
                                        <button data-testid="detail-project-empty-upload-btn" className='border border-black bg-black text-white text-xl rounded-md px-4 py-2 '
                                            type='button'
                                            onClick={() => {
                                                /*setUploadAudioModal(<NewAudioFileUploadModal handleClose={() => { setUploadAudioModal(null) }} project={project} */
                                                setUploadAudioModal(<UploadFileWithTypes handleClose={() => { setUploadAudioModal(null) }} handleNewFileUpload={handleNewFileUpload} />)
                                            }}
                                        >
                                            <div className='w-full flex justify-center items-center gap-2 whitespace-nowrap'>
                                                <DocumentArrowUpIcon className='w-6 h-6' />
                                                {t("DetailProjects.UploadFile")}
                                            </div>
                                        </button>
                                    </div>
                                )
                            }
                        </div>}
                        {currentTab == 1 && <div data-testid="detail-project-gpt-tab">
                            <div data-testid="detail-project-gpt-content" className='grid grid-cols-1  py-4 justify-evenly gap-12 items-center'>
                                <ProjectGpt data-testid="detail-project-gpt-component" project={project} />
                            </div>
                        </div>}
                        {currentTab == 2 && <div data-testid="detail-project-codes-tab">
                            <Codebook data-testid="detail-project-codebook" textCodes={textCodes} setUploadAudioModal={setUploadAudioModal} handleUpdateCode={handleUpdateCode} handleAddNewCode={handleAddNewCode} t={t} />
                        </div>}
                        {currentTab == 4 &&
                            <div data-testid="detail-project-ai-discovery-tab">
                                <AICodeView data-testid="detail-project-ai-code-view" project={project} setUploadAudioModal={setUploadAudioModal} handleUpdateCode={handleUpdateCode} handleAddNewCode={handleAddNewCode} />
                            </div>
                        }
                        {currentTab == 5 &&
                            <div data-testid="detail-project-transcription-code-tab">
                                <TranscriptionCodeView data-testid="detail-project-transcription-code-view" project={project} setUploadAudioModal={setUploadAudioModal} handleUpdateCode={handleUpdateCode} handleAddNewCode={handleAddNewCode} textCodes={textCodes} />
                            </div>
                        }
                        {currentTab == 6 && (
                            <div data-testid="detail-project-subjects-tab" className="mt-4 flex flex-col gap-4">
                                <div>
                                    {project?.subjects?.length > 0 ? (
                                        <div data-testid="detail-project-subjects-grid" className="grid grid-cols-1 lg:grid-cols-3 gap-4">
                                            {project.subjects.map(subject => (
                                                <div key={subject.uuid} data-testid={`subject-card-${subject.uuid}`} className="p-4 border rounded-lg">
                                                    <div className="flex gap-4 mb-3">
                                                        <div className="h-12 w-12 rounded-full bg-gray-100 flex items-center justify-center">
                                                            <UserIcon className="h-6 w-6 text-gray-500" />
                                                        </div>
                                                        <div className="flex-1">
                                                            <div className="flex justify-between">
                                                                <h3 className="text-lg font-medium">{subject.name}</h3>
                                                                <div className="flex gap-2">
                                                                    <div className="flex gap-2">
                                                                        <button
                                                                            data-testid={`subject-edit-btn-${subject.uuid}`}
                                                                            onClick={() => setUploadAudioModal(
                                                                                <SubjectCreationModal
                                                                                    handleClose={() => setUploadAudioModal(null)}
                                                                                    project={project}
                                                                                    subject={subject}
                                                                                    t={t}
                                                                                    onSave={(updatedSubject) => {
                                                                                        setProject(prev => ({
                                                                                            ...prev,
                                                                                            subjects: prev.subjects.map(s =>
                                                                                                s.uuid === updatedSubject.uuid ? updatedSubject : s
                                                                                            )
                                                                                        }));
                                                                                    }}
                                                                                />
                                                                            )}
                                                                            className="p-1 text-gray-500 hover:text-gray-700"
                                                                        >
                                                                            <PencilIcon className="h-5 w-5" />
                                                                        </button>
                                                                        <button
                                                                            data-testid={`subject-delete-btn-${subject.uuid}`}
                                                                            onClick={() => {
                                                                                if (window.confirm(t('DetailProjects.DeleteSubjectConfirm'))) {
                                                                                    deleteSubject(subject.uuid);
                                                                                    setProject(prev => ({
                                                                                        ...prev,
                                                                                        subjects: prev.subjects.filter(s => s.uuid !== subject.uuid)
                                                                                    }));
                                                                                }
                                                                            }}
                                                                            className="p-1 text-red-500 hover:text-red-700"
                                                                        >
                                                                            <TrashIcon className="h-5 w-5" />
                                                                        </button>

                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <p className="text-gray-600">{subject.description}</p>
                                                        </div>
                                                    </div>
                                                    {subject.property_values && <div className='text-sm text-gray-400 mt-4'>Properties:</div>}
                                                    <div className="grid grid-cols-2 gap-2 text-sm mt-2">
                                                        {subject.property_values?.map(prop => (
                                                            <div key={prop.uuid}>
                                                                <span className="font-bold">{prop.property_definition?.name}: </span>
                                                                <span>{formatPropertyValue(prop)}</span>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    ) : (
                                        <div className='w-full py-12 mt-4 mb-2 rounded-md bg-white p-4 flex flex-col items-center gap-8'>
                                            <div className='text-xl font-bold'>{t('DetailProjects.No subjects')}</div>
                                            <div className='text-base text-gray-500'>{t('DetailProjects.No subjects submessage')}</div>
                                            <img src={no_subjects} className='h-96 aspect-square mt-2' alt="" />
                                        </div>

                                    )}
                                </div>
                                <div data-testid="detail-project-subjects-actions" className="flex gap-4 mb-4 w-full justify-between">
                                    <button
                                        data-testid="detail-project-create-subject-btn"
                                        className='border border-black bg-black text-white text-sm rounded-md px-4 py-2'
                                        onClick={() => setUploadAudioModal(
                                            <SubjectCreationModal
                                                handleClose={() => setUploadAudioModal(null)}
                                                project={project}
                                                t={t}
                                                onSave={(newSubject) => {
                                                    setProject(prev => ({
                                                        ...prev,
                                                        subjects: [...(prev.subjects || []), {
                                                            ...newSubject,
                                                            property_values: newSubject.property_values.map(pv => ({
                                                                ...pv,
                                                                property_definition: project.property_definitions.find(pd => pd.id === pv.property_definition_id)
                                                            }))
                                                        }]
                                                    }));
                                                }}
                                            />
                                        )}
                                    >
                                        <div className='w-full flex justify-center items-center gap-2 whitespace-nowrap'>
                                            <UserIcon className='w-6 h-6' />
                                            {t("SubjectProperties.Create subject")}
                                        </div>
                                    </button>
                                    <div className='flex gap-4 '>
                                        <button
                                            data-testid="detail-project-subject-properties-btn"
                                            className='border border-black bg-black text-white text-sm rounded-md px-4 py-2'
                                            onClick={() => setUploadAudioModal(
                                                <SubjectPropertiesModal
                                                    handleClose={() => setUploadAudioModal(null)}
                                                    project_uuid={project.uuid}
                                                    project={project}
                                                    onSave={(updatedProject) => setProject(updatedProject)}
                                                />
                                            )}
                                        >
                                            <div className='w-full flex justify-center items-center gap-2 whitespace-nowrap'>
                                                <Cog6ToothIcon className='w-6 h-6' />
                                                {t("SubjectProperties.Create subject properties")}
                                            </div>
                                        </button>
                                        <button
                                            data-testid="detail-project-public-form-btn"
                                            className='border border-black bg-black text-white text-sm rounded-md px-4 py-2'
                                            onClick={() => setUploadAudioModal(
                                                <SubjectPublicFormModal
                                                    handleClose={() => setUploadAudioModal(null)}
                                                    project={project}
                                                    t={t}
                                                />
                                            )}
                                        >
                                            <div className='w-full flex justify-center items-center gap-2 whitespace-nowrap'>
                                                <ShareIcon className='w-6 h-6' />
                                                {t("SubjectProperties.ManagePublicForm")}
                                            </div>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}

                        {currentTab == 7 && (
                            <div data-testid="detail-project-results-tab" className="mt-4 flex flex-col gap-4">

                                {(textCodes?.some(code => code.excerpts && code.excerpts.length > 0)) ? <div data-testid="detail-project-results-content" className='flex flex-col gap-8'>
                                    <HierarchicalTables data-testid="detail-project-hierarchical-tables" data={textCodes}

                                    />

                                    <CodeFilePresenceMatrix
                                        data-testid="detail-project-presence-matrix"
                                        project={project}
                                        codes={textCodes}
                                        title={t("CategoryResults.InterviewPresenceHeader")}
                                    />
                                    {textCodes && textCodes.length > 0 && project.analysis && project.analysis.length > 0 && (
                                        <>
                                            <ErrorBoundary minimal>
                                                <PolarAreaCenterLabelsChart
                                                    data-testid="detail-project-polar-chart"
                                                    codes={textCodes}
                                                    files={project.analysis}
                                                    mode="codes-per-interview"
                                                    title={t("CategoryResults.CategoryOverallFrequencyHeader")}
                                                />
                                            </ErrorBoundary>
                                            <ErrorBoundary minimal>
                                                <PolarAreaChartsPerInterview
                                                    data-testid="detail-project-polar-charts-per-interview"
                                                    codes={textCodes}
                                                    files={project.analysis}
                                                    title={t("CategoryResults.CodeFrequncyByFileHeader")} />
                                            </ErrorBoundary>
                                        </>
                                    )}


                                </div> : <div data-testid="detail-project-empty-results" className='w-full py-12 mt-4 mb-2 rounded-md bg-white p-4 flex flex-col items-center gap-8 flex-grow'>
                                    <div className='text-xl font-bold'>{t('CategoryResults.NoCodes')}</div>
                                    <div className='text-base text-gray-500 '>{t('CategoryResults.NoCodesDescription')}</div>
                                    <img src={text_coder} className=' h-96 aspect-square mt-2'></img>
                                    <button data-testid="detail-project-empty-results-coder-btn" className='border border-black bg-black text-white text-xl rounded-md px-4 py-2 '
                                        type='button'
                                        onClick={() => {
                                            /*setUploadAudioModal(<NewAudioFileUploadModal handleClose={() => { setUploadAudioModal(null) }} project={project} */
                                            navigate("/text_coder/" + project_uuid)
                                        }}
                                    >
                                        <div className='w-full flex justify-center items-center gap-2 whitespace-nowrap'>
                                            <TagIcon className='w-6 h-6' />
                                            {t("DetailProjects.Coder")}

                                        </div>
                                    </button>
                                </div>}
                            </div>
                        )}

                        {currentTab == 8 && (
                            <div data-testid="detail-project-articles-tab">
                                <ArticlesTab data-testid="detail-project-articles-component" project={project} />
                            </div>
                        )}

                        {currentTab == 9 && (
                            <div data-testid="detail-project-bibliography-tab">
                                <BibliographyTab data-testid="detail-project-bibliography-component" projectUuid={project_uuid} />
                            </div>
                        )}

                    </Card>
                </div>
            </div >

            {projectSlideover && <div data-testid="detail-project-edit-modal">{projectSlideover}</div>}
            {uploadAudioModal && <div data-testid="detail-project-upload-modal">{uploadAudioModal}</div>}
            
            <ProjectDeletionDateSlideover
                project={project}
                isOpen={deletionSlideover}
                onClose={() => setDeletionSlideover(false)}
                onSuccess={(updatedDeletionInfo) => {
                    setDeletionInfo(updatedDeletionInfo);
                }}
            />
        </div >
    )
}

export default DetailProject
